/**
 * This replaces the legacy count down.
 */

require('../public/css/flipclock.css')
const api = require('./api')
const momentTimezone = require('moment-timezone')
const debug = require('debug')('streamspot:evenTcountdown')
const query = require('./util').qs(window)
let offset = query['offset'] ? query['offset'] : null



debug('countdown: getting upcoming broadcasts')
if (window.eventId) {
  debug('calling initCountdown - for eventId: ' + window.eventId + ' using start: ' + window.eventStart + ' and timezone: ' + window.eventTimezone)
  initCountown(window.eventStart, window.eventTimezone)
}

function initCountown(eventStart, timezone) {
  debug('initCountown: start')
  const timeOfBroadcast = momentTimezone.tz(eventStart, timezone)
  if (offset) {
    timeOfBroadcast.add(offset, 's')
  }
  const utcOffset = new Date().getTimezoneOffset()
  const nextBroadcastTime = timeOfBroadcast.utcOffset(utcOffset).toDate()
  debug('initCountown: Seconds until next time: %s', nextBroadcastTime)
  startCountown(nextBroadcastTime)
  debug('initCountown: end')
}

function startCountown(date) {
  $('#the-clock').countdown(date, function (event) {
    $(this).html(event.strftime(timeTemplate()))
  })
}

function timeTemplate() {
  return `
    Live In: %D<small> Days</small> %H<small> Hours</small> %M<small> Mins</small> %S<small> Secs</small>
    `
}



// WEBPACK FOOTER //
// ./src/eventCountdown.js